import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let route = [{
    path: '/',
    name: 'index',
    component: () => import('@/pages/dumanbet/index.vue'),
    meta: {
      title: '主页'
    },
    children: [
      {
        path: '/',
        name: 'Home',
        component: () => import('@/pages/dumanbet/homePage.vue'),
        meta: {
          title: '首页'
        }
      },
      {
        path: '/game',
        name: 'Game',
        component: () => import('@/pages/dumanbet/gamePage.vue'),
        meta: {
          title: '游戏'
        }
      },
      {
        path: '/video',
        name: 'Vidoe',
        component: () => import('@/pages/dumanbet/videoPage.vue'),
        meta: {
          title: '电子视讯'
        }
      },
      {
        path: '/login',
        name: 'Login',
        component: () => import('@/pages/dumanbet/loginPage.vue'),
        meta: {
          title: '登录'
        }
      }
    ]
  },
  {
    path: '/gameInfo',
    name: 'index',
    component: () => import('@/pages/newGame/newGameSon/gameInfo.vue'),
    meta: {
      title: '游戏中转'
    },
  },
  {
    path: '/cztx',
    name: 'index',
    component: () => import('@/pages/pc/son/pc_transaction.vue'),
    meta: {
      title: '123'
    },
  }, {
    path: '/test',
    name: 'test',
    component: () => import('../components/gameRecord.vue')
  }
]
const routers = new Router({
  mode: 'history',
  routes: route
})

export default routers



// WEBPACK FOOTER //
// ./src/router/index.js